export default __webpack_public_path__ + "static/media/chevron-up.inline.6ba7b661.svg";